import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react'
import { withStyles } from '@material-ui/core/styles';
import {portal_config} from '../../portal.config'
import { withTranslation } from 'react-i18next';
import { PlaceActiveIcon } from './icons';
const styles = theme => ({

})
class GoogleMapComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            initialRegion: [35.157322, 33.313751]
        }
    }

    render() {
        const { children, center, zoom } = this.props;
        var centerRegion = this.state.initialRegion
        if(center){
            centerRegion = [center.lat, center.lon]
        }
        const onChange = (event) =>{
            if (this.props.onRegionChangeComplete)
                this.props.onRegionChangeComplete(event)
        }
        //console.log('GoogleMapComponent initialRegion=',region)
        return (
            <div style={{width:'100%',height:'100%'}}>
                <GoogleMapReact
                    bootstrapURLKeys={{key: portal_config.apiKey}}
                    defaultZoom={10}
                    defaultCenter={this.state.initialRegion}
                    center={centerRegion}
                    zoom={zoom}
                    onChange={onChange}
                    onDragEnd={this.props.onDragEnd}
                    onClick={this.props.onClick}>
                    {children}
                    {/* <PlaceActiveIcon/> */}
                </GoogleMapReact>
            </div>
        )
    }
}
export default withStyles(styles)(withTranslation()(GoogleMapComponent))
